import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// vgm
export function vgmList(params) {
  return request({
    url: URL.seaExport.vgm,
    method: 'get',
    params
  })
}
// 发送vgm
export function sendVgm(params) {
  return request({
    url: URL.seaExport.sendVgm,
    method: 'get',
    params
  })
}
// 获取码头信息
export function querySeaHouseWharf(params) {
  return request({
    url: URL.seaExport.querySeaHouseWharf,
    method: 'get',
    params
  })
}
// 获取vgm日志
export function queryVgmLog(params) {
  return request({
    url: URL.seaExport.queryVgmLog,
    method: 'get',
    params
  })
}
// 发送vgm
export function syncManifestInfoToVgm(data) {
  return request({
    url: URL.seaExport.syncManifestInfoToVgm,
    method: 'post',
    data
  })
}
